export const emailValidation = email => {
    const emailRegExp = /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/;
    return emailRegExp.test(email) ? null : 'Please enter a valid email address'

}

export const passwordValidation = password => {
    const passwordRegExp = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-_]).{8,}$/;
    return passwordRegExp.test(password) ? null : 'Password should contains 8 symbols, One capital, One small, one digit, one special characters'

}

export const passwordMatch = (password, confirmPassword) => {
    return password === confirmPassword ? null : 'passwords should match'
}


export const requiredFieldValidation = (field, fieldName) => {
    if(fieldName === 'Phone number' && field?.trim() === '(') return `${fieldName} is required`;
    return !field?.trim() ? `${fieldName} is required` : null;
}

export const adminOrTeacher = (current) => {
    return current && current.optional && (current.optional.role === 'admin' || current.optional.role === 'teacher');
}

export const admin = (current) => {
    return current && current.optional && current.optional.role === 'admin';
}

export const groupSort = (groups) => {
    return groups.filter(el => Boolean(el))
        //alphabetical sort
        .sort((a, b) => a > b ? 1 : -1)
        // sort by index number
        .sort((a, b) => {
            return +b?.split('-')[1] - +a?.split('-')[1];
        })
}